(function() {
  // ============================================
  // Currency Converter: USD → EUR for French locale
  // ============================================

  // Constants
  const FALLBACK_RATE = 1.08;
  const SESSION_KEY = 'gt:eurRate';
  const API_TIMEOUT = 3000;
  const EU_COUNTRY_CODES = ['FR','DE','IT','ES','BE','NL','PT','AT','FI','IE','GR','LU','MT','SK','SI','EE','LV','LT','CY'];

  // State
  let currentRate = FALLBACK_RATE;
  let rateReady = false;

  // Determine EUR mode from themeVariables
  const settings = window.themeVariables && window.themeVariables.settings;
  const locale = (settings && settings.shopLocale) || '';
  const country = (settings && settings.shopCountryIso) || '';
  const isEurMode = locale === 'fr' || EU_COUNTRY_CODES.includes(country);

  // Fetch EUR/USD rate from free API
  function fetchRate() {
    // Check sessionStorage first
    const cached = sessionStorage.getItem(SESSION_KEY);
    if (cached) {
      currentRate = parseFloat(cached);
      rateReady = true;
      dispatch();
      return;
    }

    // Fetch live rate with timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT);

    fetch('https://api.exchangerate-api.com/v4/latest/USD', {
      signal: controller.signal
    })
      .then(r => r.json())
      .then(data => {
        if (data.rates && data.rates.EUR && data.rates.EUR > 0) {
          currentRate = data.rates.EUR;
          sessionStorage.setItem(SESSION_KEY, String(currentRate));
        }
      })
      .catch(() => {
        // Use fallback silently
      })
      .finally(() => {
        clearTimeout(timeoutId);
        rateReady = true;
        dispatch();
      });
  }

  // Dispatch custom event for UI consumers
  function dispatch() {
    document.dispatchEvent(new CustomEvent('currency:ready', {
      detail: { isEurMode, rate: currentRate }
    }));
  }

  // Public API
  window.CurrencyConverter = {
    /**
     * Check if EUR mode is active (French locale or EU country)
     */
    isEurMode() {
      return isEurMode;
    },

    /**
     * Get current USD→EUR rate
     */
    getRate() {
      return currentRate;
    },

    /**
     * Check if rate has been fetched
     */
    isReady() {
      return rateReady;
    },

    /**
     * Convert Shopify cents (integer) to EUR display string
     * @param {number} cents - Price in cents (e.g., 85000 = $850.00)
     * @returns {string|null} Formatted EUR string (e.g., "€1,380") or null if not EUR mode
     */
    convert(cents) {
      if (!isEurMode) return null;
      const usd = cents / 100;
      const eur = Math.round(usd * currentRate);
      return '€' + eur;
    },

    /**
     * Convert USD dollars (float) to EUR display string
     * @param {number} usd - Price in USD (e.g., 850.00)
     * @returns {string|null} Formatted EUR string or null if not EUR mode
     */
    convertDollars(usd) {
      if (!isEurMode) return null;
      const eur = Math.round(usd * currentRate);
      return '€' + eur;
    },

    /**
     * Get rate formatted for display (4 decimals)
     * @returns {string}
     */
    formatRateDisplay() {
      return currentRate.toFixed(4);
    }
  };

  // Initialize: fetch rate if EUR mode is active
  if (isEurMode) {
    fetchRate();
  } else {
    // Mark as ready immediately if not EUR mode
    rateReady = true;
    dispatch();
  }
})();
